import z from "zod";

export const SanityObjectSchema = z.object({
    _id: z.string()
});

export const LocalisedStringSchema = z.object({
    en: z.string().nullable(),
    fr: z.string().nullable()
});

export const TypedObjectSchema = z.object({
    _type: z.string(),
    _key: z.string().optional()
});

export const PortableTextBlockSchema = z.intersection(
    TypedObjectSchema,
    z.record(z.any())
);

export const LanguageSchema = z.union([z.literal("en"), z.literal("fr")]);

export const SlugSchema = z.object({
    current: z.string(),
    _type: z.literal("slug")
});

export const DateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
